module.exports = __webpack_public_path__ + "img/menu3.03c14511.svg";